import React from 'react';
import { Button, Input, Select } from 'antd';
import { Search, X } from 'lucide-react';
import { FilterBar, FilterField } from '../../common';
import { useContractFilters } from './contractElements.controller';

/**
 * Barra de filtros de contrataciones. Los filtros de canal / cliente / PDV se
 * aplican sobre los pisos de venta asignados, de modo que la inversión total
 * siempre se calcula sobre lo filtrado.
 */
function ContractActions({ onFilter, stores, clients }) {
    const f = useContractFilters({ onFilter, stores, clients });

    return (
        <FilterBar
            label="Filtros"
            className="!mb-0"
            actions={
                f.hasActiveFilters && (
                    <Button type="text" icon={<X />} onClick={f.onClear}>
                        Limpiar
                    </Button>
                )
            }>
            <FilterField label="Buscar" className="w-full sm:w-60">
                <Input
                    value={f.searchValue}
                    onChange={(e) => f.onSearch(e.target.value)}
                    placeholder="Buscar contratación..."
                    prefix={<Search className="text-surface-400" />}
                    allowClear
                />
            </FilterField>
            <FilterField label="Canal" className="w-full sm:w-44">
                <Select value={f.channel} options={f.channelOptions} onChange={f.onChannelChange} placeholder="Canal" />
            </FilterField>
            <FilterField label="Cliente" className="w-full sm:w-52">
                <Select
                    value={f.clientId}
                    options={f.clientOptions}
                    onChange={f.onClientChange}
                    showSearch
                    optionFilterProp="label"
                    placeholder="Cliente"
                    popupMatchSelectWidth={false}
                />
            </FilterField>
            <FilterField label="Piso de venta" className="w-full sm:w-56">
                <Select
                    value={f.storeId}
                    options={f.storeOptions}
                    onChange={f.onStoreChange}
                    showSearch
                    optionFilterProp="label"
                    placeholder="Piso de venta"
                    popupMatchSelectWidth={false}
                />
            </FilterField>
            <FilterField label="Tipo" className="w-full sm:w-52">
                <Select
                    value={f.type}
                    options={f.typeOptions}
                    onChange={f.onTypeChange}
                    showSearch
                    optionFilterProp="label"
                    placeholder="Tipo de contratación"
                    popupMatchSelectWidth={false}
                />
            </FilterField>
        </FilterBar>
    );
}

export default ContractActions;
